const stage = (process.env.REACT_APP_STAGE ?? "dev") as "prod" | "dev";

const imageSizeLimitInMegabytes = 3;
const imageSizeLimitInBytes = imageSizeLimitInMegabytes * 2 ** 20;

const config = {
  stage,
  apiName: `back-kayter-crm-seo-${stage}`,
  hostPrefix:
    process.env.REACT_APP_BLOG_URL ?? "https://dev-blog-oceanproxy.netlify.app",
  defaultBlog: "Oceanproxy",
  imageTemporisation: 5000,
  imageSizeLimitInMegabytes,
  imageSizeLimitInBytes,
  imageToHeavyMessage: `Image trop lourde, la limite est de ${imageSizeLimitInMegabytes} MB`,
};

export default config;
